/**
 * Gymly Shop — Community popup (V8)
 * Isolated vanilla JS.
 * V7: Horizon scrolls .page-wrapper.
 * V8: do not treat customer_posted as marketing subscribed (localStorage).
 * Force-preview (?gcp_preview=1) unchanged from V5/V6.
 */
(function () {
  'use strict';

  if (window.__GYMLY_COMMUNITY_POPUP_BOOTED__) return;
  window.__GYMLY_COMMUNITY_POPUP_BOOTED__ = true;

  var STORAGE_DISMISS = 'gymly_community_popup_dismiss_until';
  var STORAGE_SUBSCRIBED = 'gymly_community_popup_subscribed';
  var STORAGE_SESSION = 'gymly_community_popup_shown_session';

  /* Resolved once — Horizon desktop uses .page-wrapper as overflow-y:auto scroller. */
  var scrollRoot = null;
  var scrollRootLabel = 'unresolved';

  function hasQaPreviewParam() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('gcp_preview') === '1' || params.get('gymly_community_popup') === '1';
    } catch (e) {
      return false;
    }
  }

  function hasDebugParam() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('gcp_debug') === '1';
    } catch (e) {
      return false;
    }
  }

  function isDiagMode() {
    try {
      if (window.Shopify && window.Shopify.designMode) return true;
    } catch (e) {}
    return hasQaPreviewParam() || hasDebugParam();
  }

  function diag() {
    if (!isDiagMode()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[GCP]');
    try {
      console.info.apply(console, args);
    } catch (e) {}
  }

  diag('js loaded');

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function safeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function parseBool(v) {
    return String(v) === 'true';
  }

  function describeScrollRoot(el) {
    if (!el) return 'none';
    if (el === window) return 'window';
    if (el === document.scrollingElement) return 'document.scrollingElement';
    if (el === document.documentElement) return 'document.documentElement';
    if (el === document.body) return 'document.body';
    if (el.classList && el.classList.contains('page-wrapper')) return '.page-wrapper';
    if (el.id) return '#' + el.id;
    return (el.tagName || 'element').toLowerCase();
  }

  /**
   * Horizon (base.css ≥990px): html/body overflow:hidden; .page-wrapper overflow-y:auto.
   * Resolve once — no DOM scans on scroll.
   */
  function resolveScrollRoot() {
    if (scrollRoot) return scrollRoot;

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) {
      var style = window.getComputedStyle(wrapper);
      var oy = style && style.overflowY;
      if (oy === 'auto' || oy === 'scroll' || wrapper.scrollHeight > wrapper.clientHeight + 1) {
        scrollRoot = wrapper;
        scrollRootLabel = describeScrollRoot(wrapper);
        return scrollRoot;
      }
    }

    var se = document.scrollingElement || document.documentElement;
    scrollRoot = se;
    scrollRootLabel = describeScrollRoot(se);
    return scrollRoot;
  }

  function getWindowScrollY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  /** Actual vertical scroll position for whichever root the theme uses. */
  function getScrollPosition() {
    var root = resolveScrollRoot();
    var rootTop = 0;
    if (root && root !== window) {
      rootTop = root.scrollTop || 0;
    }
    var winTop = getWindowScrollY();
    var docTop =
      (document.scrollingElement && document.scrollingElement.scrollTop) ||
      document.documentElement.scrollTop ||
      (document.body && document.body.scrollTop) ||
      0;
    return Math.max(rootTop, winTop, docTop);
  }

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (!style) return false;
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    return true;
  }

  function isDismissed() {
    if (safeGet(STORAGE_SUBSCRIBED) === '1') return true;
    var until = safeGet(STORAGE_DISMISS);
    if (!until) return false;
    var ts = Number(until);
    if (!Number.isFinite(ts)) return false;
    return Date.now() < ts;
  }

  function markDismissed(days) {
    var ms = Math.max(0, Number(days) || 7) * 24 * 60 * 60 * 1000;
    safeSet(STORAGE_DISMISS, String(Date.now() + ms));
  }

  function markSubscribed() {
    safeSet(STORAGE_SUBSCRIBED, '1');
  }

  function clearPopupState() {
    try {
      window.localStorage.removeItem(STORAGE_DISMISS);
      window.localStorage.removeItem(STORAGE_SUBSCRIBED);
      window.sessionStorage.removeItem(STORAGE_SESSION);
    } catch (e) {}
  }

  /**
   * Only treat competing UI as open when it is actually visible.
   * V5 bug: any [aria-modal="true"] in the DOM (incl. closed drawers) blocked forever.
   * Force-preview bypassed this; normal trigger did not — matching live QA.
   */
  function competingUiOpen() {
    var openDialogs = document.querySelectorAll('dialog[open]');
    for (var d = 0; d < openDialogs.length; d++) {
      if (openDialogs[d].id === 'GymlyCommunityPopupDialog') continue;
      if (isElementVisible(openDialogs[d])) return true;
    }

    var modals = document.querySelectorAll('[aria-modal="true"]');
    for (var m = 0; m < modals.length; m++) {
      if (modals[m].id === 'GymlyCommunityPopupDialog') continue;
      if (isElementVisible(modals[m])) return true;
    }

    var cookieSelectors = [
      '#shopify-pc__banner',
      '#shopify-pc__prefs',
      '.shopify-pc__banner',
      '#shopify-consent-banner',
      '#onetrust-banner-sdk',
      '.ot-sdk-container',
      '#CookieBot',
      '.cc-window',
    ];
    for (var i = 0; i < cookieSelectors.length; i++) {
      var el = document.querySelector(cookieSelectors[i]);
      if (el && isElementVisible(el)) return true;
    }
    return false;
  }

  function getFocusable(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
      });
  }

  function initRoot(root) {
    if (!root || root.dataset.gcpReady === '1') return;
    root.dataset.gcpReady = '1';
    diag('mounted');

    var dialog = qs(root, '[data-gcp-dialog]');
    var panel = qs(root, '[data-gcp-panel]');
    /* V8: form lives inside the dialog (Horizon-style), not as an ancestor of <dialog>. */
    var form = qs(root, 'form#GymlyCommunityPopupForm') || qs(root, 'form');
    if (!dialog || !panel) return;

    var enabled = parseBool(root.dataset.enabled);
    var homepageOnly = parseBool(root.dataset.homepageOnly);
    var isHomepage = parseBool(root.dataset.isHomepage);
    var allowTemplate =
      root.dataset.allowTemplate == null ? true : parseBool(root.dataset.allowTemplate);
    var designMode = parseBool(root.dataset.designMode) || !!(window.Shopify && window.Shopify.designMode);
    var alreadySubscribed = parseBool(root.dataset.customerSubscribed);
    var scrollThreshold = Number(root.dataset.scrollThreshold || 300);
    var minDelayMs = Number(root.dataset.minDelaySeconds || 3) * 1000;
    var dismissDays = Number(root.dataset.dismissDays || 7);
    /* customer_posted / form.posted_successfully? ≠ Mailabonnenter; markers come from Liquid form. */
    var hashTargetsPopup = (window.location.hash || '') === '#GymlyCommunityPopupForm';
    var postedSuccess =
      !!qs(root, '[data-gcp-posted-success]') ||
      (parseBool(root.dataset.postedSuccess) && hashTargetsPopup);
    var hasErrors =
      !!qs(root, '[data-gcp-has-errors]') ||
      (parseBool(root.dataset.hasErrors) && hashTargetsPopup);
    var qaPreview = hasQaPreviewParam();
    var debugMode = hasDebugParam();

    diag('initialized', { enabled: enabled, qaPreview: qaPreview, allowTemplate: allowTemplate });

    resolveScrollRoot();
    if (debugMode) {
      diag('scroll element =', scrollRootLabel);
      diag('window.scrollY =', getWindowScrollY());
      diag('actualScrollTop =', getScrollPosition());
    }

    var opened = false;
    var lastFocus = null;
    /* State machine: BOTH must be true for normal open. Either edge re-evaluates. */
    var timeReady = false;
    var scrollReady = getScrollPosition() >= scrollThreshold;
    var loadTime = Date.now();
    var competeRetryTimer = null;
    var scrollListenerTarget = null;

    function lockScroll() {
      document.documentElement.classList.add('gymly-community-popup-open');
    }

    function unlockScroll() {
      document.documentElement.classList.remove('gymly-community-popup-open');
    }

    function eligibilityBlockReason() {
      if (!enabled) return 'disabled';
      if (!allowTemplate) return 'template_blocked';
      if (homepageOnly && !isHomepage) return 'homepage_only';
      if (alreadySubscribed) return 'customer_subscribed';
      if (isDismissed()) return 'dismissed_or_subscribed_storage';
      if (safeSessionGet(STORAGE_SESSION) === '1') return 'shown_session';
      return null;
    }

    function openDialog(opts) {
      opts = opts || {};
      if (opened) return;

      if (!opts.force) {
        var block = eligibilityBlockReason();
        if (block) {
          if (debugMode) diag('blocked reason =', block);
          return;
        }
        /* Competing UI: do not silent-fail — caller/maybeOpen retries. */
        if (competingUiOpen()) {
          if (debugMode) diag('blocked reason =', 'competing_ui');
          return;
        }
      }

      diag('opening popup', opts);
      lastFocus = document.activeElement;
      opened = true;
      /* Session key only after an actual open — never on init. */
      if (!qaPreview && !designMode) {
        safeSessionSet(STORAGE_SESSION, '1');
      }
      lockScroll();

      try {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      } catch (err) {
        dialog.setAttribute('open', '');
      }

      var focusTarget =
        qs(dialog, '[data-gcp-success-message]') ||
        qs(dialog, '[data-gcp-error-message]') ||
        qs(dialog, '[data-gcp-email]') ||
        qs(dialog, '[data-gcp-close]');
      if (focusTarget && typeof focusTarget.focus === 'function') {
        window.setTimeout(function () {
          focusTarget.focus();
        }, 10);
      }
    }

    function closeDialog(persistDismiss) {
      if (!opened) return;
      opened = false;
      if (typeof dialog.close === 'function') {
        try {
          dialog.close();
        } catch (e) {
          dialog.removeAttribute('open');
        }
      } else {
        dialog.removeAttribute('open');
      }
      unlockScroll();
      if (persistDismiss && !qaPreview) {
        markDismissed(dismissDays);
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-gcp-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* Success "Continue shopping" closes without multi-day dismiss. */
        var persistDismiss = !btn.hasAttribute('data-gcp-success-close');
        closeDialog(persistDismiss);
      });
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog(true);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(true);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !opened) return;
      var focusable = getFocusable(panel);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        var submit = qs(form, '[data-gcp-submit]');
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
        }
      });
    }

    if (postedSuccess) {
      /* V8: do NOT set STORAGE_SUBSCRIBED — customer_posted does not prove marketing consent. */
      diag('form posted successfully (customer_posted); awaiting Admin marketing verification');
      openDialog({ force: true, afterSubmit: true });
      return;
    }

    if (hasErrors) {
      openDialog({ force: true, afterSubmit: true });
      return;
    }

    /* V5 force-preview: immediate open, bypass storage/scroll/delay. */
    if (qaPreview) {
      clearPopupState();
      diag('preview force-open');
      openDialog({ force: true });
      return;
    }

    function maybeOpen() {
      if (debugMode) {
        diag('eligible =', !eligibilityBlockReason());
        diag('timeReady =', timeReady);
        diag('scroll element =', scrollRootLabel);
        diag('window.scrollY =', getWindowScrollY());
        diag('actualScrollTop =', getScrollPosition());
        diag('scrollReady =', scrollReady);
        diag('maybeOpen');
      }

      if (opened) {
        if (debugMode) diag('blocked reason =', 'already_opened');
        return;
      }

      var block = eligibilityBlockReason();
      if (block) {
        if (debugMode) diag('blocked reason =', block);
        return;
      }

      if (!timeReady) {
        if (debugMode) diag('blocked reason =', 'time_not_ready');
        return;
      }
      if (!scrollReady) {
        if (debugMode) diag('blocked reason =', 'scroll_not_ready');
        return;
      }

      if (competingUiOpen()) {
        if (debugMode) diag('blocked reason =', 'competing_ui_retry');
        if (!competeRetryTimer) {
          competeRetryTimer = window.setTimeout(function () {
            competeRetryTimer = null;
            maybeOpen();
          }, 800);
        }
        return;
      }

      openDialog();
    }

    /* Timer edge → re-evaluate (covers scroll-first then timer). */
    window.setTimeout(function () {
      timeReady = Date.now() - loadTime >= minDelayMs - 25;
      maybeOpen();
    }, Math.max(0, minDelayMs));

    /* Scroll edge → re-evaluate (covers timer-first then scroll). */
    function detachScrollListeners() {
      window.removeEventListener('scroll', evaluateScroll);
      if (scrollListenerTarget && scrollListenerTarget !== window) {
        scrollListenerTarget.removeEventListener('scroll', evaluateScroll);
      }
    }

    function evaluateScroll() {
      if (getScrollPosition() >= scrollThreshold) {
        scrollReady = true;
        detachScrollListeners();
        maybeOpen();
      }
    }

    /* Horizon desktop: listen on .page-wrapper; keep window as mobile/fallback. */
    scrollListenerTarget = resolveScrollRoot();
    if (
      scrollListenerTarget &&
      scrollListenerTarget !== window &&
      scrollListenerTarget !== document.documentElement &&
      scrollListenerTarget !== document.body &&
      scrollListenerTarget !== document.scrollingElement
    ) {
      scrollListenerTarget.addEventListener('scroll', evaluateScroll, { passive: true });
    }
    window.addEventListener('scroll', evaluateScroll, { passive: true });
    /* Restored / already-scrolled position — do not require a new scroll event. */
    evaluateScroll();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gymly-community-popup]');
    roots.forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
